// System Logs Getters

export const getLogsList = state => {
  return state.logsList
}

export const getLogInfo = state => {
  return state.logInfo
}
